export function shouldDisplayParam(p) {
  if (p["graph display"] && p["graph display"] === "show") return true;
  if (p["graph display"] && (p["graph display"] === "Not used" || p["graph display"] === "not show")) return false;
  return true;
}

// Zero-padded binary string, LSB last (so callers reverse() it to index by
// bit position). `dec` falsy (0, undefined, NaN) used to short-circuit to ""
// - a shorter-than-`length` string that silently shifts every bit position
// after it once .split('').reverse()'d, e.g. DI/DO rows reading the wrong
// input's value whenever the underlying register happened to read exactly 0.
export function dec2bin(dec, length = 16) {
  return numToString(dec || 0, 2, length);
}

function padStart(string, length, char) {
  //  can be done via loop too:
  //    while (length-- > 0) {
  //      string = char + string;
  //    }
  //  return string;
  return length > 0 ?
    padStart(char + string, --length, char) :
    string;
}

function numToString(num, radix, length) {
  const numString = num.toString(radix);
  return numString.length >= length ?
    numString :
    padStart(numString, length - numString.length, "0")
}
